import React, { Component } from "react";
import LayoutPrematch from "./HOCs/LayoutPrematch/LayoutPrematch";
import LayoutLive from "./HOCs/LayoutLive/LayoutLive";
import LayoutAdmin from "./HOCs/LayoutAdmin/LayoutAdmin";
import LayoutUnauthenticated from "./HOCs/LayoutUnauthenticated/LayoutUnauthenticated";
import { Route, Switch, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Advertisement from "./HOCs/Advertisement/Advertisement";
// import * as actions from "./store/actions/index";

class App extends Component {
  render() {
    // return <Layout />;

    return (
      <Switch>
        <Route path="/advertisement" component={Advertisement} />
        <Route
          path="/live"
          component={
            this.props.adminInfo && this.props.adminInfo.UserToken !== ""
              ? LayoutAdmin
              : LayoutLive
          }
        />
        <Route path="/admin" component={LayoutAdmin} />
        <Route path="/unauthenticated" component={LayoutUnauthenticated} />
        <Route path="/" component={LayoutPrematch} />
      </Switch>
    );
  }
}

const mapStateToProps = state => {
  return {
    isAuthenticated: true,
    isAdminLoggedIn: state.rrNavigation.isAdminLoggedIn,
    adminInfo: state.rrNavigation.adminInfo
  };
};

export default withRouter(connect(mapStateToProps)(App));



// WEBPACK FOOTER //
// ./src/App.js